import { isInArray } from "utils/general";
import { OrderService } from "../../entities";
import { OrderStatus } from "../../entities";

export const validatePlaceLength = (value) => {
    if (value && value.length > 64) {
      return "osfc.messages.validation.validatePlaceLength";
    }
  };


export const validateArea = (value, allValues) => {
  const statusesRequireArea = [OrderStatus.LOADING_COMPLETED, OrderStatus.ORDER_COMPLETED, OrderStatus.DEVIATION];
  if (allValues["service"] === OrderService.intoPlukkStorage && allValues["eta_date"] && isInArray(statusesRequireArea, allValues["status"]) && !value){
    return "ra.validation.required"
  }
};

export const validateStoragePlace = (value, allValues) => {
  const statusesRequireStoragePlace = [
    OrderStatus.PLUKK_STARTED, OrderStatus.PLUKK_COMPLETED, OrderStatus.LOADING_READY,
    OrderStatus.LOADING_STARTED, OrderStatus.LOADING_COMPLETED, OrderStatus.ORDER_COMPLETED,
  ];
  if (allValues["service"] === OrderService.intoPlukkStorage && allValues["etd_date"]
    && isInArray(statusesRequireStoragePlace, allValues["status"]) && !value){
    return "ra.validation.required"
  }
};

// export const validateRankField = (value, allValues) => {

//   if (value !== null && value < 1){
//     return "ra.validation.order_rank"
//   }
// };  
